import moment from 'moment';

export const momenti18n = () => {
  moment.updateLocale('es', {
    weekdaysShort: 'DOM_LUN_MAR_MIER_JUE_VIE_SAB'.split('_'),
    weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_'),
  });
};
